<template>
    <div>
        <nav-breadcrumb :menu="[{label: ' 分公司列表'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import citysOptions from '../../utils/citys'
    export default {
        name: "BranchOfficeList",
        data(){
            return{
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '分公司名称',
                        field: 'bo__branchName'
                    },
                    {
                        label: '负责人',
                        field: 'bo__contactPerson'
                    },
                    {
                        label: '联系方式',
                        field: 'bo__contactNo'
                    },
                    {
                        label: '所属地区',
                        field: 'bo__province',
                        formatter: function (r,c,v) {
                            return  (citysOptions.find(item=>item.code === Number(r.bo__province))||{}).province+'/'+
                                (citysOptions.find(item=>item.code === Number(r.bo__city))||{}).city+'/'+
                                (citysOptions.find(item=>item.code === Number(r.bo__district))||{}).district
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '编辑',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'edit',
                                            query: {
                                                branchId: row.bo__branchId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                }
                            }
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.$router.push({
                                path: 'add'
                            })
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        bo__branchName:'',
                        bo__branchStatus:'',
                    },
                    columns: [

                        {
                            label: '渠道商名称',
                            component: 'el-input',
                            field: 'bo__branchName'
                        },
                        {
                            label: '状态',
                            component: 'el-select',
                            field: 'bo__branchStatus',
                            options: [
                                {
                                    label:'禁用',
                                    value:'Closed'
                                },
                                {
                                    label:'启用',
                                    value:'Active'
                                }
                            ],
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getBranchOfficeList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
            removeItem: function (index, row) {
                removeItem(
                    xhr.deleteBranchOffice,
                    {
                        'bo.branchId' : row.bo__branchId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchOfficeList.vue